/**
 * Check if first Int64 is less than second
 *
 * @param {import('./Int64Type.js').BrandedInt64} a - First value
 * @param {import('./Int64Type.js').BrandedInt64} b - Second value
 * @returns {boolean} True if a < b
 */
export function lessThan(a, b) {
	return a < b;
}
